import customImg from "../../../images/customize.jpg";
import resumeImg from "../../../images/2.jpg";
import previewImg from "../../../images/preview.jpg";
import jobImg from "../../../images/jobs.png";
import coverImg from "../../../images/cover-letter.jpg";
import autoApplyImg from "../../../images/auto-apply-img.png";

const featureTutorial = [
    {
        slug: "job-automation",
        hub: "job-hub",
        title: "Automate Job Application",
        link: "/user/dashboard/job-hub",
        videoSource: "https://www.youtube.com/embed/CDH9HIHdtaE/",
        description: `Join thousands who've secured positions at top companies using our AI-powered resume builder,
                    automated job matching, and interview preparation tools.`,
        cards:[
        {
            title: "Create or Upload Resume",
            description: "Bubble Ai uses this step to understand and analyze you for best possible matches, after which a first downloadable resume draft is generated and you receive your first job connections.",
            image: customImg
        },
        {
            title: "Preview and Download",
            description: "Bubble Ai analyzes and optimizes your resume with industry-specific keywords and metrics for maximum ATS compatibility. You can preview, choose between our exhaustive region-specific templates, and download in PDF",
            image: resumeImg
        },
        {
            title: "Job Connections",
            description: "An analysis of your skills, industry experience and job preferences is used to connect you with 90%+ interview chance job opportunities, including insider connections, tailored ice-breakers and possible job referrals.",
            image: previewImg
        },
        {
            title: "Total Application Assistant",
            description: "Let Bubble Ai automatically complete your application for you! Our intelligent system will: Fill out application forms, tailor resumes for each job and cover letters for each application, Allow you to review and submit",
            image: autoApplyImg
        },
        {
            title: "Interactive Voice Interview Mock",
            description: "Super Intelligent AI Interview coach: performs deep company research, prepare possible and known questions based on this and generate tailored answers based on your data. It also analyzes your voice for jitters, giving you all the confidence and saving you 70% time",
            image: jobImg
        },
        {
            title: "External Application Assistant",
            description: "Plug Bubble Ai into other job platforms/application pages to generate resumes, cover letters and complete application form answers. Found a job elsewhere, just plug Bubble Ai in and make your life easy!",
            image: coverImg
        },
    ],
   },
    {

        slug: "exam-simulator",
        hub: "exam-hub",
        title: "Exam Simulation",
        link: "/user/dashboard/mock",
        videoSource: "https://www.youtube.com/embed/0W6hepruatk/",
        description: `Join thousands who've secured positions at top companies using our AI-powered resume builder,
                    automated job matching, and interview preparation tools.`,
        cards:[
            {
                title: "Tell Me the Exam",
                description: "Tell me which exam mock you want to simulate and I will help you with bring it up. Note that this is a Beta version and some exams might not yet be fully available.",
                image: customImg
            },
            {
                title: "Generate Exam Mock",
                description: "Bubble Ai then generates a timed mock exam using the real life blueprints including real past questions, rules, duration, topics, number of questions etc. Giving you a truly real feel and familiarization opportunity for as many takes as you want to make you completely comfortable.",
                image: resumeImg
            },
            {
                title: "Grade Exam Mock",
                description: "You can choose to submit exam when you are finished but if the timer elapses before, exam is automatically submited and Bubble Ai then grades you using the actual exam grading rules; giving you an insight on how prepared for the exam you are in real time.",
                image: previewImg
            },
            {
                title: "Study Plan & Insights",
                description: "You also get a tailored study plan based on identified weaknesses with a progress tracker. You never have to spend hours studying irrelevant pages of materials again, just pure focus. Plus get major exam insights including time management tips, Interactive AI tutoring, topic prioritization, error solutions, common pitfalls, peer benchmarking and much more.",
                image: jobImg
            },
            {
                title: "Free Study Materials",
                description: "Bubble Ai also aggregates free learning materials from videos, articles, and other resources to enhance your study experience, all within the web app.",
                image: coverImg
            }
        ],
    }



];


export default featureTutorial;